export { default } from './AccordionTitle';



// WEBPACK FOOTER //
// ./src/components/atoms/AccordionTitle/index.js